export default{
    getInteracciones({commit},data){
        return new Promise((resolve, reject) => {
            axios.post('interaccionesGraficos',data)
                .then(response => {                    
                    commit('setDataGraficos',response.data)
                    resolve(response)

                })
                .catch(error =>{                    
                    resolve()
                })
        })
    }
}